import React from 'react';
import {useHistory} from "react-router-dom";
import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';
import {Security, LoginCallback} from '@okta/okta-react';
import { getAuthClientIdFromEnv, getAuthIssuerFromEnv } from '../../Utilities/utilities';

const config = {
  oidc: {
    clientId: getAuthClientIdFromEnv(),
    issuer: getAuthIssuerFromEnv(),
    redirectUri: window.location.origin + '/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: false,
  },
}
const oktaAuth = new OktaAuth(config.oidc)

const OktaAuthProvider = ({children}) => {
  const history = useHistory();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    const basepath = history.createHref({});
    const originalUriWithoutBasepath = originalUri.replace(basepath, '/');
    history.replace(toRelativeUrl(originalUriWithoutBasepath, window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  )
};

export default OktaAuthProvider;
